import { useEffect, useRef, useState } from 'react';
import { Modal } from 'antd';
import posthog from '@libs/posthog';
import { POSTHOG_SLACK_COMMUNITY_SURVEY_ID } from '@config/posthogSurveys';
import SlackIcon from './SlackIcon';
import leoLogo from '@assets/logo-compact-dark.svg';

const FALLBACK_LINK =
  'https://join.slack.com/t/leocollective/shared_invite/zt-3ttysfq9t-NyGpw5JZDCrdYXXziWPieA';

const SlackCommunityPopup = () => {
  const [visible, setVisible] = useState(false);
  const [slackUrl, setSlackUrl] = useState(FALLBACK_LINK);
  const shownRef = useRef(false);

  useEffect(() => {
    posthog.getActiveMatchingSurveys((surveys) => {
      const survey = surveys.find(
        (s: { id: string }) => s.id === POSTHOG_SLACK_COMMUNITY_SURVEY_ID,
      );
      if (!survey) return;

      const question = survey.questions?.[0];
      if (question && 'link' in question && question.link) {
        setSlackUrl(question.link);
      }

      setVisible(true);
      if (!shownRef.current) {
        shownRef.current = true;
        posthog.capture('survey shown', {
          $survey_id: POSTHOG_SLACK_COMMUNITY_SURVEY_ID,
        });
      }
    }, true);
  }, []);

  const handleJoin = () => {
    posthog.capture('survey sent', {
      $survey_id: POSTHOG_SLACK_COMMUNITY_SURVEY_ID,
      $survey_response: 'joined',
    });
    window.open(slackUrl, '_blank', 'noopener,noreferrer');
    setVisible(false);
  };

  const handleDismiss = () => {
    posthog.capture('survey dismissed', {
      $survey_id: POSTHOG_SLACK_COMMUNITY_SURVEY_ID,
    });
    setVisible(false);
  };

  return (
    <Modal
      open={visible}
      onCancel={handleDismiss}
      footer={null}
      closable
      centered
      width={380}
      styles={{
        body: { padding: 0 },
        container: {padding: 0, overflow: 'hidden'}
      }}
    >
      <div className="bg-[var(--color-light400)] h-[120px] flex items-center justify-center">
        <div className="relative w-[88px] h-14 flex items-center">
          <div className="w-12 h-12 aspect-square rounded-full bg-white flex items-center justify-center">
            <SlackIcon size={26} />
          </div>
          <div className="-ml-3 w-14 h-14 aspect-square rounded-full bg-white flex items-center justify-center border-[3px] border-[var(--color-light400)] z-10">
            <img src={leoLogo} alt="Leo" width={34} height={34} />
          </div>
        </div>
      </div>
      <div className="p-6 text-center">
        <h3 className="text-lg font-bold text-gray-900 mb-2">
          Join the Leo Slack Community
        </h3>
        <p className="text-sm text-gray-500 mb-5 leading-relaxed">
          Learn prompting techniques, get tips from expert AI marketers, and
          discover new ways to use Leo
        </p>
        <button
          className="w-full py-3 border-none rounded-lg bg-leo-primary text-white text-[15px] font-semibold cursor-pointer transition-opacity hover:opacity-90"
          onClick={handleJoin}
        >
          Join
        </button>
      </div>
    </Modal>
  );
};

export default SlackCommunityPopup;
